import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Modal, List, Badge, Avatar } from 'antd';

import * as ToolRequest from '../../tools/ToolRequest';

import SpinFull from '../../components/SpinFull';
import CropNameBadge from '../../components/CropNameBadge';

export default function HomeSiteCardProductionDetailModal({
  visible = false,
  onCancel = () => {},
  siteId,
  cropId,
  cropName,
  typeLabel,
  type,
  date,
}) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!visible || !siteId || !cropId || !type || !date) {
      setData(null);
      return;
    }

    setData(null);

    (async () => {
      const beginAt = moment(date).startOf('day').toISOString();
      const endAt = moment(date).endOf('day').toISOString();

      const res = await ToolRequest.request('GET', '/v1/farm-production-record', {
        siteId,
        cropId,
        type,
        beginAt,
        endAt,
        count: 1000,
      });

      const records = res.data.sort((a, b) => {
        return new Date(a.recordedAt) - new Date(b.recordedAt);
      });

      setData(records);
    })();
  }, [visible, siteId, cropId, type, date]);

  const titleParts = [typeLabel, date].filter(Boolean);

  return (
    <Modal
      title={(
        <>
          {cropName && (
            <span style={{ marginRight: 8 }}>
              <CropNameBadge name={cropName} />
            </span>
          )}
          <span style={{marginRight: 8}}>{titleParts.join(' · ')}</span>
          <Badge count={data ? data.length : 0} />
        </>
      )}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      bodyStyle={{paddingTop: 4, paddingBottom: 4}}
    >
      {data ? (
        data.length ? (
          <List
            dataSource={data}
            renderItem={(item, i) => {
              const details = [
                moment(item.recordedAt).format('HH:mm'),
                item.zone,
                item.remarks,
              ].filter(Boolean);

              return (
                <List.Item
                  key={item.id}
                  actions={[
                    <span>
                      {item.amount} plants
                      {item.weight ? ` · ${item.weight}g` : ''}
                    </span>
                  ]}
                >
                  <List.Item.Meta
                    avatar={<Avatar size="small">{i + 1}</Avatar>}
                    title={`Entry ${i + 1}`}
                    description={details.join(' · ') || moment(item.recordedAt).format('YYYY-MM-DD HH:mm')}
                  />
                </List.Item>
              );
            }}
          />
        ) : (
          <div style={{ padding: '16px 0', textAlign: 'center', color: '#999' }}>
            No records found for this date.
          </div>
        )
      ) : <SpinFull style={{ height: 80 }} />}
    </Modal>
  );
};
